// Section markdown carries placement tokens like {{table:t1}} and
// {{chart:c1}} on their own or inline. Splitting keeps the narrative as
// markdown segments with artifact slots in between; artifacts never
// referenced by a token render after the body.

export type MarkdownSegment =
  | { kind: 'text'; text: string }
  | { kind: 'table' | 'chart'; id: string }

const TOKEN_PATTERN = /\{\{(table|chart):([\w-]+)\}\}/g

export function splitMarkdownTokens(markdown: string): MarkdownSegment[] {
  const segments: MarkdownSegment[] = []
  let cursor = 0
  for (const match of markdown.matchAll(TOKEN_PATTERN)) {
    const start = match.index ?? 0
    const text = markdown.slice(cursor, start)
    if (text.trim()) segments.push({ kind: 'text', text })
    segments.push({
      kind: match[1] as 'table' | 'chart',
      id: match[2],
    })
    cursor = start + match[0].length
  }
  const tail = markdown.slice(cursor)
  if (tail.trim()) segments.push({ kind: 'text', text: tail })
  return segments
}

export function placedArtifactIds(segments: MarkdownSegment[]): Set<string> {
  const ids = new Set<string>()
  for (const segment of segments) {
    if (segment.kind !== 'text') ids.add(segment.id)
  }
  return ids
}
